import { render, staticRenderFns } from "./management-library-purpose-view.vue?vue&type=template&id=d07fbd08"
import script from "./management-library-purpose-view.vue?vue&type=script&lang=js"
export * from "./management-library-purpose-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports